import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5c2a536"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "foot" }

import { onMounted, ref } from 'vue'
import { WarningFilled } from '@element-plus/icons-vue'
import { t } from '@/plugins/i18n'
import { useRtfix, useUser } from '@/store'
import { request } from '@/config/request/interceptors'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const translate = ref('')

const open = ref(false)

const user = useUser()

onMounted(async () => {
  const shop = document.getElementById('toggle-shop')
  if (shop) {
    const { x, bottom } = shop?.getBoundingClientRect()
    translate.value = `translate(calc(${x}px - 36%),${bottom + 4}px)`
    console.log(user)
    if (!user.updateShopPopup) {
      open.value = true
      request.customer.updateShopPopup.updateShopPopup()
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_Transition, { name: "el-fade-in-linear" }, {
    default: _withCtx(() => [
      (open.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle({ transform: translate.value }),
            class: "new-user-tip"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(WarningFilled))
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)('提示')), 1)
            ]),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('已为您自动创建店铺，如有需要，您可自行修改店铺信息')), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(user).updateShopPopup = !(open.value = false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('稍后处理')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_unref(user).updateShopPopup = !(open.value = false); _ctx.$router.push(_unref(useRtfix)('AuthorizedStore'));})
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('修改')), 1)
                ]),
                _: 1
              })
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})